var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { hasCrypto } from './caniuse';
/**
 * PEM data between pk markers i.e.
 * -----BEGIN PUBLIC KEY-----
 *  PEM_data
 * -----END PUBLIC KEY-----
 */
const PublicKeyPEM = `
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAwrH3OVUx2rjoJ0EISFsB
HaeKjtc58t+I3kyTKvHDJbNlELvBjTJB6Xgv5tMBuztgOtbvYuzkM88Lg0XUSIrd
2XtjaQYFetQXtrA2eWTBw3cb4GXRvauz6goCl2njTcd5fe8nLQaqWeZho7uHh5tr
+J44IvKyL59zTi5C8yBzp0OjnbVbaYO3YqzQUzIrbIuew7Um4VsrmPMA2ImFYywj
G2aHrKgOfadWtVLXXKUefqql6RDklrYsxElEp0EBQVIvMvIVVNnk1FtLtBzJET+p
WjLdAP2qgK5TUNzAzkZyK42tGbaubaNFo7zcsMoqNxQtAwzCA/PjD/3VcX8Z3B/j
GX4Dx2O4BtdkvICuDrJGcHzrU0MMacZMquBCJeuelFHdsdewHvuZeb9O7lWdgztn
uYQGXuHuW8RzzYIqe70WcLVu3IRFzS3dw82izGu/g4LrH5fG00pqaVTpfB7WN9V5
wqSH0958RVd1Im2eiUZNqBt4PV+hSMa6c0StkgHxQSjhonkc40MkxWkRqkjVDpGz
OIToVF+aqs0IQyrfmK7DzqKW1ul8kkww3FG49YVjNr4+JW79oC6gKeLMx9yHUoHf
m/vN8tJJujetkj0qKSsndovTHHVmm2aQo2vMxcjVTGsCx5lot949QzcwEizryfOF
D6JgZtboIL3e7a1swqVm1msCAwEAAQ==
`;
function str2ab(str) {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i += 1) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
}
function hex2bin(str) {
    const hexLen = str.length;
    if ((hexLen & 1) !== 0) {
        throw new Error('Invalid sign length');
    }
    const dataLen = hexLen >> 1;
    const sBuffer = new ArrayBuffer(dataLen);
    const bytes = new Uint8Array(sBuffer);
    let bidx = 0;
    for (let idx = 0; idx < hexLen; idx += 2, bidx += 1) {
        const hbyte = str[idx];
        const lbyte = str[idx + 1];
        const word = ((parseInt(hbyte, 16) & 0xf) << 4) | (parseInt(lbyte, 16) & 0xf);
        bytes[bidx] = word;
    }
    return sBuffer;
}
export const verifySignature = (data, sig, format = 'hex') => __awaiter(void 0, void 0, void 0, function* () {
    if (!hasCrypto()) {
        return false;
    }
    if (!sig) {
        return new Error('Missing required signature');
    }
    const binaryDer = str2ab(window.atob(PublicKeyPEM));
    let pk;
    try {
        pk = yield crypto.subtle.importKey('spki', binaryDer, {
            name: 'RSASSA-PKCS1-v1_5',
            hash: 'SHA-256',
        }, false, ['verify']);
    }
    catch (err) {
        throw new Error('Import key error');
    }
    if (!pk) {
        return false;
    }
    let sBuffer;
    if (format === 'hex') {
        // hex string to bin ab
        sBuffer = hex2bin(sig);
    }
    else {
        sBuffer = str2ab(sig);
    }
    return window.crypto.subtle.verify({
        name: 'RSASSA-PKCS1-v1_5',
    }, pk, sBuffer, typeof data === 'string' ? str2ab(data) : data);
});
